import { ArrowRight, CheckCircle2 } from "lucide-react";
import { PHOTOS } from "../lib/brand";
import { useQuote } from "../context/QuoteContext";
import { useProducts } from "../hooks/useProducts";
import { PageHero } from "../components/site/PageHero";
import { ProductCard } from "../components/site/ProductCard";

const SPECS = ["Water tenders · 2,000L to 12,000L configurations", "Foam & ARFF crash tenders for refineries and airports", "Hydraulic platforms up to 42 m working height", "Rescue tenders, pickups and quick response vehicles"];

export default function Vehicles() {
  const { openQuote } = useQuote();
  const vehicles = useProducts().filter((p) => ["Fire Tenders", "Aerial & Rescue"].includes(p.category));
  return (
    <>
      <PageHero eyebrow="Fire trucks & vehicles" title="A platform for every response profile." copy="Purpose-built vehicles for municipal fire services, industrial facilities, airports, infrastructure and government fleets." image={PHOTOS.tender} />
      <section className="section wrap detail-grid">
        <div>
          <p className="eyebrow">Vehicle platforms</p><h2>Specify the right capability.</h2>
          <p>We configure chassis, tank capacity, pump systems, compartments and safety markings around the operating environment — then support the tender from first drawing to delivery.</p>
          <button className="button button-orange" onClick={() => openQuote({ source: "vehicles-page" })} data-testid="vehicles-quote-button">Discuss your requirement <ArrowRight size={17} /></button>
        </div>
        <div className="spec-list">{SPECS.map((x, i) => <div key={x} data-testid={`vehicle-spec-${i}`}><span>0{i + 1}</span>{x}<CheckCircle2 /></div>)}</div>
      </section>
      <section className="section slate"><div className="wrap pgrid">{vehicles.map((p, i) => <ProductCard key={p.slug} product={p} index={i} />)}</div></section>
    </>
  );
}
